import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import getPageTitle from '@/utils/get-page-title'
import sysMenuApi from '@/api/system/sysMenu'
import { filterAsyncRoutes } from '@/store/modules/permission'
import { filterHomeRoutes, isHomePath, landingPath } from '@/utils/home-access'
import { consolidateAiTrainMenus } from '@/utils/ai-train-navigation'

NProgress.configure({ showSpinner: false })
const whiteList = ['/login', '/password']
// Deliberately not persisted: reloading must recheck current server permissions.
let initializedToken = null

router.beforeEach(async(to, from, next) => {
  NProgress.start()
  document.title = getPageTitle(to.meta.title)
  const token = getToken()
  if (!token) {
    initializedToken = null
    store.commit('user/SET_HOME_ACCESS', false)
    store.commit('user/SET_ROUTE', [])
    if (whiteList.includes(to.path)) next()
    else next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
    NProgress.done()
    return
  }

  try {
    let checkedHome = false
    if (initializedToken !== token) {
      store.commit('user/SET_HOME_ACCESS', false)
      store.commit('user/SET_ROUTE', [])
      await store.dispatch('user/getInfo')
      await store.dispatch('user/getPermissions')
      const allowed = await store.dispatch('user/getHomeAccess')
      checkedHome = true
      const response = await sysMenuApi.getRouters()
      if (!response || String(response.code) !== '0' || !Array.isArray(response.data)) {
        throw new Error('菜单加载失败，请重新登录')
      }
      const menus = consolidateAiTrainMenus(filterHomeRoutes(response.data, allowed))
      localStorage.setItem('menuList', JSON.stringify(menus))
      filterAsyncRoutes(menus)
      initializedToken = token
      // The wildcard may have resolved a dynamic page to /404 before its menu loaded.
      if (to.redirectedFrom) {
        const original = router.resolve(to.redirectedFrom).route
        if (original.matched.length && original.path !== '/404' && original.fullPath !== to.fullPath) {
          next({ path: to.redirectedFrom, replace: true })
          NProgress.done()
          return
        }
      }
    }

    const homeTarget = isHomePath(to.path) || to.matched.some(record => record.meta && record.meta.requiresHome)
    if ((homeTarget || to.path === '/login') && !checkedHome) {
      await store.dispatch('user/getHomeAccess')
    }
    if (to.path === '/login' || (homeTarget && !store.state.user.homeAccess)) {
      next({ path: landingPath(store.state.user.routes || [], store.state.user.homeAccess, path => router.resolve(path)), replace: true })
      NProgress.done()
      return
    }
    next()
  } catch (error) {
    initializedToken = null
    store.commit('user/SET_HOME_ACCESS', false)
    store.commit('user/SET_ROUTE', [])
    localStorage.removeItem('menuList')
    localStorage.removeItem('routes')
    await store.dispatch('user/resetToken')
    Message.error(error.message || '权限加载失败，请重新登录')
    next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
    NProgress.done()
  }
})

router.afterEach(() => NProgress.done())
